<template>
  <v-card id="pass40" class="ep-rechner-box">
    <v-col cols="12" class="p-0">
      <div class="v-card__title p-0">
        <h2 class="v-card--head--title">{{ selectedLang.W9Tile3 }}</h2>
      </div>
    </v-col>

    <v-card-text>
      <v-form ref="resultform" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12">
            <div class="v-card--msg">
              <h2 class="ep-rechner-h2">{{ selectedLang.W9Tile4 }}</h2>
              <h2
                class="ep-rechner-h2"
                v-html="
                  formatDBText(selectedLang.W9Tile5, {
                    'dataEP.t1.dtod': dataEP.t1.dtod,
                    'dataEP.t1.cidtod': dataEP.t1.cidtod,
                  })
                "
              ></h2>
            </div>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="clientMail"
              :rules="emailRules"
              :disabled="sent"
              :label="selectedLang.W9Tile6"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <template v-if="transferMessage">
      <v-row>
        <v-col cols="12">
          <div class="v-card--msg">
            <h2 class="ep-rechner-h2">
              {{ resultMessage }}
            </h2>
          </div>
        </v-col>
      </v-row>
    </template>
    <v-card-actions>
      <v-col cols="12" v-if="!sent">
        <v-btn
          id="confirm-reas"
          block
          class="btn-ep-back-to"
          @click="sendW9()"
          >{{ selectedLang.W9Tile7 }}</v-btn
        >
      </v-col>
      <v-col v-else cols="12">
        <v-btn
          block
          color=""
          class="btn-ep-next-step"
          @click="restart"
          >{{ selectedLang.W9Tile8 }}</v-btn
        >
      </v-col>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
export default {
  name: "W9Tile",
  data: function () {
    return {
      clientMail: "",
      sent: false,
      transferMessage: false,
      successMessage: this.$store.state.selectedLang.W9Tile1,
      errorMessage: this.$store.state.selectedLang.W9Tile2,
      resultMessage: "",
    };
  },
  computed: {
    ...mapState([
      "selectedDiv",
      "dataEP",
      "pass40",
      "emailRules",
      "flN",
      "flD",
      "noChange",
      "selectedLang",
    ]),
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "setSelectedDiv",
      "setVar",
      "killRun",
    ]),
    sendW9() {
      if (this.$refs.resultform.validate()) {
        let payload = {
          flD: this.flD,
          flN: this.flN,
          clientMail: this.clientMail,
          t1: this.dataEP.t1,
        };
        this.transferMessage = true;
        if (this.sendDataW9(payload)) {
          this.sent = true;
          this.resultMessage = this.successMessage;
          this.setVar({ pos: "noChange", val: true });
        } else {
          this.resultMessage = this.errorMessage;
        }
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    async sendDataW9(payload) {
      await axios
        .post(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/saveW9.php",
          {
            flD: payload.flD,
            flN: payload.flN,
            clientMailW9: payload.clientMail,
            dt: payload.t1.dt,
            dtod: payload.t1.dtod,
            cidtod: payload.t1.cidtod,
          }
        )
        .then((response) => {
          if (response.data.res == "200") {
            return true;
          } else {
            return false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    restart() {
      this.killRun({ vm: this });
    },
  },
};
</script>
